export default __webpack_public_path__ + "static/media/slider-img8.7ca86037.jpg";